import { fetchDashboardDataFromSheet } from "../../api/sheetsApi";
import { useEffect, useState } from "react";
import BarChartSection from "./BarChartSection";
import TableSection from "./TableSection";
import ToppersSection from "./ToppersSection";
import OverviewHeader from "./OverviewHeader";
import SummaryCards from "./SummaryCard";

const AcademicDashboard = () => {
  const [sectionData, setSectionData] = useState([]);
  const [summary, setSummary] = useState({});
  const [title, setTitle] = useState("");
  const [topPerformers, setTopPerformers] = useState([]);
  const [studentsNeedingSupport, setStudentsNeedingSupport] = useState([]);
  const [toppersTitle, setToppersTitle] = useState("");
  const [toppersSubtitle, setToppersSubtitle] = useState("");
  const [currentMonth, setCurrentMonth] = useState("May 2026");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAcademicsData = async () => {
      try {
        const data = await fetchDashboardDataFromSheet();
        setSectionData(data?.academicsSectionData || []);
        setSummary(data?.academicsSummary || {});
        setTitle(data?.academicsTitle || "");
        setTopPerformers(data?.topPerformers || []);
        setStudentsNeedingSupport(data?.studentsNeedingSupport || []);
        setToppersTitle(data?.toppersTitle || "");
        setToppersSubtitle(data?.toppersSubtitle || "");
        setCurrentMonth(data?.currentMonth || "May 2026");
      } catch (err) {
        console.error(err);
        setError(err.message || "Unable to load academics data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchAcademicsData();
  }, []);

  if (loading) {
    return (
      <div className="p-2 bg-gray-100 min-h-[100dvh] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-[100dvh] items-center justify-center bg-gray-100 p-2">
        <div className="rounded-xl bg-white px-5 py-4 text-sm font-medium text-red-500 shadow-sm">
          <p>{error}</p>
          
        </div>
      </div>
    );
  }

  return (
    <div className="p-2 bg-gray-100 min-h-[100dvh] space-y-6">
      <OverviewHeader currentMonth={currentMonth} />

      <SummaryCards summary={summary} />

      <div className="w-full">
        <BarChartSection data={sectionData} />
      </div>

      <ToppersSection
        topPerformers={topPerformers}
        studentsNeedingSupport={studentsNeedingSupport}
        title={toppersTitle || "Toppers & Students Needing Support"}
        subtitle={toppersSubtitle}
      />

      <TableSection data={sectionData} examTitle={title} />
    </div>
  );
};

export default AcademicDashboard;
